<template>
<div id="kb_edit"></div>
</template>

<script lang="ts">
import { TocaEditor, type DocInfo } from '@toca/toca-edit';
import { mapActions, mapState } from 'vuex';
import '@toca/toca-edit/dist/style.css';
import { getBrowser } from '../../utils/browser';
import { HocuspocusModule } from '../../store/types';
// @ts-ignore
import { BATCH_AUTH_DETAIL_LIST } from '@/constants/FileShare';
import { geCurrentNodeInfo } from '../../core/api/file';
import { getNodeInfo } from '../../store/kbTreeNodeModule';
import { finishDocumentLoad } from '../../utils/sentry';

import { clearCookieAndToLogin } from '../../login';
import {
    saviorEventUUID,
    setSaviorConfigure,
    updateSaviorData
} from '../../utils/savior';
import { isCancel } from 'axios';
const BASE_URL = import.meta.env.VITE_APP_API_URL;
export default {
    name: '',
    components: {},
    data() {
        return {
            tocaEditor: null
        };
    },
    emits: ['onSelectionUpdate','onAwarenessChange'],
    computed: {
        ...mapState({
            doc_id: state => state.kbModule.doc_id,
            isCanEdit: state => state.kbEditModule.isCanEdit,
            doc_info: state => state.kbEditModule.doc_info,
            fileName: state => state.kbEditModule.doc_info?.fileInfo?.fileName,
            treeNodes: state => state.kbTreeNodeModule.treeNodes,
            isNewDoc: state => state.kbEditModule.isNewDoc,
            userInfo: state => state.userModule,
            showtype: state => state.kbModule.showtype,
            wikiI18n: (state: any) => state.kbModule.wikiI18n,
            showVisitRecord: (state: any) =>
                state.kbModule.wikiSpaceInfo?.wikiSpaceSettings?.showVisitRecord,
            isReadOnly: state => state.kbModule.wikiSpaceInfo?.wikiSpaceSettings?.readOnly,
            isCanCopy: (state) => {
                const { auth } = state.kbEditModule.doc_info;
                // ALL一定能够复制
                if (auth === 'ALL') return true;

                return state.kbEditModule.isCanCopy;
            },
        }),
        isMobile() {
            return getBrowser().isMobile;
        }
    },
    watch: {
        // isNewDoc: {
        //   handler(val) {
        //     console.log('xxxxxxxxxxxxisNewDocisNewDocisNewDoc', val)
        //     if (this.tocaEditor && val) {
        //       console.log('xxxxxxxxxxxx,设置isNewDoc状态focus',)
        //       this.tocaEditor?.editor?.commands?.focus(val)
        //     }
        //   },
        //   immediate: true
        // },
        // isCanEdit: {
        //   handler(val, old) {
        //     // console.log('isCanEditisCanEditisCanEdit', val, old);
        //     // if (this.tocaEditor) {
        //     //   this.tocaEditor.setIsCanEdit(val);
        //     // }
        //   },
        //   immediate: true
        // },
        doc_id(val) {
            if (this.tocaEditor) {
                this.tocaEditor?.setFileId(val);
            }
        },
        fileName: {
            deep: true,
            handler(val) {
                if (this.tocaEditor) {
                    this.tocaEditor?.updateDocInfo({...this.doc_info,...{fileName:val}});
                }
            }
        },
        showVistRecord(val) {
            this.tocaEditor?.setShowVisitRecord(val);
        },
        isReadOnly: {
            handler(val) {
                this.tocaEditor?.setIsReadOnly(val);
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions({
            setIsNewDoc: 'kbEditModule/setIsNewDoc',
            updateDocTitle: `${HocuspocusModule.moduleSpaceName}${HocuspocusModule.UPDATE_DOC_TITLE_ACTION}`,
            updateSelectDocName: `kbTreeNodeModule/updateSelectDocName`,
            setTocaEditor: `kbEditModule/setTocaEditor`,
            setDocOwner: `kbEditModule/setDocOwner`
        }),
        // 获取文件树节点
        _findTreeNode(fileId, treeNodes) {
            if (!treeNodes || !fileId) return null;
            let treeNode = null;
            for (let i = 0; i < treeNodes.length; i++) {
                if (treeNodes[i].fileId === fileId) {
                    treeNode = treeNodes[i];
                    break;
                } else {
                    if (
                        treeNodes[i].children &&
                        treeNodes[i].children.length > 0
                    ) {
                        treeNode = this._findTreeNode(
                            fileId,
                            treeNodes[i].children
                        );
                        if (treeNode) break;
                    }
                }
            }
            return treeNode;
        },
        _fixedDocInfo() {
            let docInfo = this.doc_info;
            let newDocInfo: DocInfo = {};
            if (docInfo.fileInfo) {
                newDocInfo.creator =
                    this._findTreeNode(docInfo.fileInfo?.fileId, this.treeNodes)
                        ?.creator ?? {};
                newDocInfo.auth = docInfo.fileInfo?.auth ?? '';
                newDocInfo.fileName = docInfo.fileInfo?.fileName ?? '';
                newDocInfo.createTime = docInfo.fileInfo?.createTime ?? 0;
            }
            return {
                ...docInfo,
                ...newDocInfo
            };
        },
        _onTitleHasChange(title: string, fid?: string) {
            if (this.doc_info?.fileInfo?.fileName?.trim() === title?.trim())
                return;
            if (fid && this.doc_info.fileInfo?.fileId === fid) {
                this.doc_info.fileInfo.fileName = title;
            } else if (!fid && this.doc_info.fileInfo) {
                this.doc_info.fileInfo.fileName = title;
            }
            const that = this;
            this.updateDocTitle({ title, fid }).then(resp => {
                // console.log('--------------------resp:', resp);
                if (resp.data.code === 200) {
                    let fileId = resp.data.data.fileId;
                    // console.log('--------------------fileid',fileId,'name:',title);
                    let treeNode = getNodeInfo(that.treeNodes, fileId);
                    // console.log('--------------------treeNode',treeNode);
                    treeNode.fileName = title;
                    treeNode.fileNamePrefix = title;
                    treeNode.title = title;
                }

                // that.doc_info.fileName = title;
                // that.doc_info.fileInfo.fileName = title;
                // that.updateSelectDocName(that.doc_info.fileInfo);
            });
        },
    },
    mounted() {
        console.timeEnd('time1111111111111');

        console.log(
            'time1111111111111 xxxx',
            new Date().getTime() - performance.timing.navigationStart
        );

        let userData = {
            ...this.userInfo,
            ...this.userInfo.userDetail
        };

        this.tocaEditor = new TocaEditor('#kb_edit', {
            fileId: this.doc_id,
            isFocus: false, //this.isCanEdit && this.isNewDoc,
            isCanEdit: this.isCanEdit,
            isCanCopy: this.isCanCopy,
            env: import.meta.env.MODE,
            showDirectory: true,
            showVisitRecord: this.showVisitRecord,
            showWaterMark: true,
            mobilePreview: this.isMobile,
            docInfo: this._fixedDocInfo(),
            onAwarenessChange: data => {
                this.$emit('onAwarenessChange', data);
            },
            onTitleChange: (data: string, fid?: string) => {
                this._onTitleHasChange(data, fid);
            },
            onSelectionUpdate:(content: any) => {
                this.$emit('onSelectionUpdate', content);
            },
            onChangeEditStatus:(isCanEdit: boolean) => {
                this.$emit('onChangeEditStatus', isCanEdit);
            },
            onNoPermission: () => {
                clearCookieAndToLogin();
            },
            commentToLogin: () => {
                clearCookieAndToLogin();
            },
            userInfo: this.userInfo,
            showtype: this.showtype,
            userData: userData,
            markdownSettingsCode: 'FILE.WIKI_ENABLED_MARKDOWN_PLUGIN',
            savior: {
                saviorEventUUID,
                setSaviorConfigure,
                updateSaviorData
            },
            locale: this.wikiI18n
        });
        this.tocaEditor.editor.on('synced', () => {
            debugger;
            finishDocumentLoad('success', this.doc_id, 'DOCUMENT');
        });
        window['tocaEditor'] = this.tocaEditor;
        this.setTocaEditor(this.tocaEditor);

        this.tocaEditor?.setIsReadOnly(this.isReadOnly);

        geCurrentNodeInfo(this.doc_id).then(resp => {
            const data = resp?.data?.data;
            if (!data) return;
            let doc_info = this._fixedDocInfo();
            doc_info.auth = data.auth;
            doc_info.creator = data.creator;
            doc_info.fileName = data.fileName;
            this.setDocOwner(data.owner);
            this.tocaEditor?.updateDocInfo({
                ...data,
                ...doc_info
            });
        });
    },
    unmounted() {
        finishDocumentLoad('cancelled', this.doc_id, 'DOCUMENT');
        this.tocaEditor?.destroy();
        this.tocaEditor = null;
        this.setTocaEditor(undefined);
        window['tocaEditor'] = undefined;
    }
};
</script>

<style lang="scss" scoped>
#kb_edit {
    flex: 1;
    display: flex;
    min-width: 0;
    overflow: v-bind("isMobile ? 'scroll' : 'hidden'");
}
</style>
